import { Link } from "react-router-dom";
import Header from "./Header";

export default function LegalMentions() {
return (
    <div className="min-h-screen bg-[#0D1117] text-[#E6EDF3] px-6 sm:px-10 lg:px-20 py-16 pt-32">
    
    <Header />
    
    <div className="max-w-4xl mx-auto bg-[#161B22] border border-[#21262D] rounded-2xl p-8 shadow-[0_0_30px_rgba(59,130,246,0.15)]">
        
        <h1 className="text-3xl sm:text-4xl font-bold mb-6">
        <span className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
            Legal Mentions
        </span>
        </h1>

        <div className="space-y-6 text-[#9BA6B3] leading-relaxed">
        
        <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Website Publisher</h2>
            <p>
            <span className="text-[#E6EDF3]">BoostMyHook</span> is published by{" "}
            <strong className="text-[#E6EDF3]">Hugo Senee — Sole Proprietor</strong> (France).<br />
            Email:{" "}
            <a href="mailto:hugosenee.pro@gmail.com" className="text-[#3B82F6]">
                hugosenee.pro@gmail.com
            </a>
            </p>
        </section>

        <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Hosting</h2>
            <ul className="list-disc ml-5 space-y-1">
            <li>Website (Frontend): Vercel, Inc.</li>
            <li>API (Backend): Render</li>
            <li>Database: MongoDB Atlas — MongoDB, Inc.</li>
            </ul>
        </section>

        <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Intellectual Property</h2>
            <p>
            All designs, logos, and content on this platform are the exclusive property of their respective owners.
            Any reproduction without authorization is prohibited.
            </p>
        </section>

        <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Disclaimer</h2>
            <p>
            BoostMyHook provides insights and recommendations for informational purposes only.
            Results and performance cannot be guaranteed.
            Users remain responsible for their uploaded content.
            </p>
        </section>

        <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Report Content</h2>
            <p>
            To report an issue or request moderation, please contact us:{" "}
            <a href="mailto:hugosenee.pro@gmail.com" className="text-[#3B82F6]">
                hugosenee.pro@gmail.com
            </a>
            </p>
        </section>

        <p className="text-xs text-[#6E7681] mt-8">
            Last update: November 4th, 2025
        </p>
        </div>

        <div className="mt-8">
        <Link to="/legal/privacy" className="text-[#8B949E] hover:text-[#3B82F6]">
            → Privacy Policy
        </Link>
        </div>
    </div>
    </div>
);
}
